export const MAX_INTEGRATION_UNAVAILABLE_MESSAGE =
  'Интеграция MAX временно недоступна: ведутся технические работы';

export const INTEGRATIONS_DROPDOWN_ITEMS = [
  {
    key: 'whatsapp',
    label: 'WhatsApp',
  },
  {
    key: 'email',
    label: 'Email',
  },
  {
    key: 'social_media',
    label: 'Social Media',
  },
];

export const VAT_CODES = [
  { value: 1, label: 'Без НДС' },
  { value: 2, label: 'НДС по ставке 0%' },
  { value: 3, label: 'НДС по ставке 10%' },
  { value: 4, label: 'НДС по ставке 20%' },
  { value: 5, label: 'НДС по расчетной ставке 10/110' },
  { value: 6, label: 'НДС по расчетной ставке 20/120' },
  { value: 7, label: 'НДС по ставке 5%' },
  { value: 8, label: 'НДС по ставке 7%' },
  { value: 9, label: 'НДС по расчетной ставке 5/105' },
  { value: 10, label: 'НДС по расчетной ставке 7/107' },
  { value: 11, label: 'НДС по ставке 22%' },
  { value: 12, label: 'НДС по расчетной ставке 22/122' },
];

export const TAX_SYSTEM_CODES = [
  { value: 1, label: 'Общая система налогообложения' },
  { value: 2, label: 'Упрощенная (УСН, доходы)' },
  { value: 3, label: 'Упрощенная (УСН, доходы минус расходы)' },
  { value: 4, label: 'Единый налог на вмененный доход (ЕНВД)' },
  { value: 5, label: 'Единый сельскохозяйственный налог (ЕСН)' },
  { value: 6, label: 'Патентная система налогообложения' },
];
